import axios from 'axios'
import router from '../router/router'
import UserBus from '../utils/buses/UserBus'

axios.defaults.baseURL = process.env.VUE_APP_API_URL || '/'

axios.interceptors.request.use(config => {
    const token = UserBus.token
    config.headers['Content-Type'] = 'application/json'
    if (token) {
        config.headers.Authorization = 'Bearer ' + token
    }
    return config
}, error => {
    return Promise.reject(error)
})

axios.interceptors.response.use(response => {
    return response
}, error => {
    const originalRequest = error.config

    // add response if not found. This is needed for network requests that do not return an error. for example the server is down
    if (!error.response) {
        error.response = {
            status: 500,
            statusText: error.message
        }
    }

    // attempt to refresh token
    // TODO - add this when refresh functionality exists
    if (error.response.status === 401
          && !originalRequest.url.includes('login')
          && !originalRequest.url.includes('refresh-token')
          // TODO - make this check match route better
          && !originalRequest.url.includes('password')
    ) {
        UserBus.logout()
        router.push({ name: 'login' })

        // TODO - make a global error message function, that catches a 401 and returns an appropriate message
        // What is happening is the 401 happens, causing the normal catch to fire
        // that normal catch has an error switch but no 401 case is defined
        // so the defaultErrorMessage is shown instead of a proper 401 error
        return Promise.reject(error.response)
    }

    // !!IMPORTANT!! - if axios error is caused by a cancel token, return error
    // this is needed so isCancel works properly in error handlers of the components
    if (axios.isCancel(error)) {
        return Promise.reject(error)
    } else {
        // try to throw response of error, else throw error
        return Promise.reject(error.response || error)
    }
})

// public instance of axios
const axiosPublicInstance = axios.create({
    baseURL: process.env.VUE_APP_API_URL || '/'
})

axiosPublicInstance.interceptors.response.use(
    response => {
        return response
    }, error => {
        if (!error.response) {
            error.response = {
                status: 500,
                statusText: error.message
            }
        }

        return Promise.reject(error.response || error)
    }
)

export const axiosPublic = axiosPublicInstance
